import EventEmitter from 'events';
import LoggerWrapper from '../../modules/logger-wrapper';
import { getSafeAudioContext, convertToMonoWithSilence } from './helpers';

const logger = new LoggerWrapper('MEDIA_CORE', 'SafeAudioTrack', LoggerWrapper.DEBUG);
logger.setRemoteVerbosity(LoggerWrapper.DEBUG);
class SafeAudioTrack extends EventEmitter {
	originalTrack = null;
	track = null;
	sourceNode = null;
	stateChangeWatcher;

	constructor(track = null) {
		super();
		this.originalTrack = track;
		this.stateChangeWatcher = this.resetStateChangeWatcher();
	}

	boot() {
		this.audioContext = getSafeAudioContext();
		const mediaStream = new MediaStream([this.originalTrack]);

		const originSourceNode = this.audioContext.createMediaStreamSource(mediaStream);
		this.sourceNode = convertToMonoWithSilence(originSourceNode, this.audioContext);

		// Creating destination mediaStream/AudioNode
		const dest = new MediaStreamAudioDestinationNode(this.audioContext, {
			channelCount: 1,
			channelCountMode: 'explicit',
		});

		this.sourceNode.connect(dest);
		this.track = dest.stream.getAudioTracks()[0];

		this.audioContext.addEventListener('statechange', this.handleAudioContextState);
	}

	handleAudioContextState = (e) => {
		if (e.target.state === 'suspended') {
			// more than 10 seconds since last time the audio context suspended than reset watcher or first suspend
			if (
				this.stateChangeWatcher.lastTimeStamp === 0 ||
				e.timeStamp - this.stateChangeWatcher.lastTimeStamp > this.stateChangeWatcher.threshold.time
			) {
				this.stateChangeWatcher.firstTimeStamp = e.timeStamp;
			}
			// in the last 10 seconds the audio context suspended more than threshold
			if (
				e.timeStamp - this.stateChangeWatcher.firstTimeStamp > this.stateChangeWatcher.threshold.time &&
				this.stateChangeWatcher.count > this.stateChangeWatcher.threshold.count
			) {
				logger.warn(`AudioContext suspended more than declared threshold`, {
					audioContext: e.target,
					watcherSettings: this.stateChangeWatcher,
				});
				this.emit('audio:suspended', e.target.state);
			}

			logger.debug('AudioContext suspended', {
				state: e.target.state,
				audioContext: e.target,
			});

			this.stateChangeWatcher = {
				...this.stateChangeWatcher,
				count: ++this.stateChangeWatcher.count,
				lastTimeStamp: e.timeStamp,
			};
			this.audioContext.resume().then(
				() => {
					logger.debug('AudioContext resume success', {
						audioContext: e.target,
					});
				},
				(err) => {
					logger.error('Failed resume audioContext', {
						audioContext: e.target,
						error: err,
					});
				}
			);
		}
	};

	resetStateChangeWatcher() {
		return {
			firstTimeStamp: 0,
			lastTimeStamp: 0,
			count: 0,
			threshold: { count: 3, time: 10000 },
		};
	}

	stop() {
		this.audioContext.removeEventListener('statechange', this.handleAudioContextState);
	}
}

export default SafeAudioTrack;
